import { makeVar } from '@apollo/client';
import { emptyString } from 'utils/constants';

export const expenseNameVar = makeVar(emptyString);
